import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowToPlay } from '../components/HowToPlay';
import { FinalCTA } from '../components/FinalCTA';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Nav />
      <main>
        <Hero />
        <Features />
        <HowToPlay />
        <FinalCTA />
      </main>

      {/* Simple Footer */}
      <footer className="py-8 bg-gray-50 border-t border-gray-200 text-center text-gray-500 text-sm">
        <p>© {new Date().getFullYear()} Shengji. All rights reserved.</p>
      </footer>
    </div>
  );
}
